import numeral from 'numeral';
import 'numeral/locales/es';

numeral.localeData( 'es' ).currency.symbol = '€';
numeral.localeData( 'en' ).currency.symbol = '€';
